import { Alert, Form } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import variables from "../../../styles/utils.module.scss";
import CheckboxWithLabel from "../../../components/CheckboxWithLabel";
import axios from "axios";
import { getMessagesUserType, serverUrl } from "../../../helpers/utility";
import { mutate } from "swr";
import InputWithLabel from "../../../components/inputWithLabel";
import InputWithSelect from "../../../components/inputWithSelect";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";

function CloseEnquiryModal({ enquiry, placement, location, show, close, size, user }) {
  const {
    formState: { errors },
    reset,
  } = useForm();
  const [sent, markSent] = useState(false);
  const [enquiryData, setEnquiryData] = useState(null);


  if (typeof close !== "function") {
    console.error(`CloseEnquiryModal missing close function!`);
    return <></>;
  }

  useEffect(() => {
    return () => {
      resetModal();
    };
  }, []);

  function resetModal() {
    markSent(false);
    setEnquiryData(null);
    reset();
  }

  async function sendCloseEnquiry() {
    try {
      const response = await axios.put(`${serverUrl}/enquiry`, {
        _id: enquiry?._id,
        placementId: placement._id,
        careProviderLocationId: location._id,
        careProviderOrganisationId: location.careProviderOrganisationId,
        closedBy: user?.email,
        closedAt: new Date().toISOString(),
        cancelled: true,
        completed: false,
      });

      if (response && response?.data?.result?._id) {
        markSent(true);
        setEnquiryData(response.data.result);
        close();

      }
    } catch (error) {
      console.error(`Close enquiry error: ${error}`);
      close();
    }
  }

  return (
    <Modal show={show} onHide={close} size={size || "lg"} centered>
      <Modal.Header closeButton>
        <Modal.Title>Close Enquiry</Modal.Title>
      </Modal.Header>

      {!sent ? (
        <>
          <Modal.Body>
            <Form>
              <p>
                Are you sure you want to close this enquiry?
              </p>
            </Form>
          </Modal.Body>

          <Modal.Footer>
            <Button
              variant="secondary"
              onClick={() => {
                close();
                resetModal();
              }}
            >
              No, go back
            </Button>
            <Button variant="primary" onClick={sendCloseEnquiry}>
              Close Enquiry
            </Button>
          </Modal.Footer>
        </>
      ) : null}
    </Modal>
  );
}

export default CloseEnquiryModal;
